import { Col, notification, Row } from 'antd';
import { plantApi } from 'api/plantApi';
import { viewersApi } from 'api/viewUserApi';
import { useAppSelector } from 'app/hooks';
import { selectIsDisable } from 'features/Login/authSlice';
import { plantInfo } from 'models';
import { ViewerInfo } from 'models/viewers';
import moment from 'moment';
import * as React from 'react';
import { HiMinusCircle } from 'react-icons/hi';
import style from './ItemPlantList.module.scss';

export interface ItemPlantOfViewerProps {
  itemViewer: ViewerInfo;
  item: plantInfo;
  setPlantList: (array: plantInfo[]) => void;
}

export default function ItemPlantOfViewer({
  itemViewer,
  item,
  setPlantList,
}: ItemPlantOfViewerProps) {
  const [itemPlant, setItemPlant] = React.useState<plantInfo>(item);
  const isDisable = useAppSelector(selectIsDisable);

  React.useEffect(() => {
    (async () => {
      try {
        const response: plantInfo = await plantApi.fetchPlantInfo({
          type: 'plant_id',
          id: item.id,
        });
        setItemPlant({ ...itemPlant, ...response });
      } catch (error) {
        console.log('Failed to fetch plant details', error);
      }
    })();
  }, []);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const onDeleteItemPlant = async (value: string) => {
    try {
      await viewersApi.removePlantToViewer({ viewer_id: itemViewer.id, plant_id: value });
      const res = await viewersApi.getPlantsByViewerId(itemViewer.id);
      setPlantList(res);
      openNotificationWithIcon('success', 'Delete plant successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'Delete plant failed!');
    }
  };
  return (
    <Row className={style.root}>
      <Col span={4}>{itemPlant.code}</Col>
      <Col span={8}>{itemPlant.label}</Col>
      <Col span={5}>{itemPlant.system_size} kW</Col>
      <Col span={7} className={style.label_and_btn}>
        {moment(itemPlant.installation_date).format('YYYY-MM-DD')}
        {!isDisable && (
          <HiMinusCircle
            className={style.icon_delete}
            onClick={() => {
              onDeleteItemPlant(itemPlant.id);
            }}
          />
        )}
      </Col>
    </Row>
  );
}
